<template>
  <v-app dark>

    <!-- TOOLBAR -->
    <toolbar-main :toolbarTitle="pageName" :extension="'extension'"></toolbar-main>

    <!-- CONTENT (ROUTER) -->
    <v-content>
      <router-view/>
    </v-content>
    
    <!-- FOOTER -->
    <!-- <footer-main/> -->
    <v-footer absolute app class="justify-center">
      <span>
        &copy; 2018 - AmmoNyte Systems LLC
      </span>
    </v-footer>

  </v-app>
</template>

<script>
import ToolbarMain from './components/navigation/Toolbar.vue'
import FooterMain from './components/navigation/Footer.vue'

export default {
  name: 'App',
  components: {
    'toolbar-main': ToolbarMain,
    'footer-main': FooterMain
  },
  data () {
    return {
      fixed: false,
      pageName: 'AmmoNyte'
    }
  },
  methods: {
    setToolbarTitle: function () {
      this.toolbarTitle = this.getPageName()
    },
    getPageName: function () {
      return this.pageName
    },
    setPageName: function (name) {
      this.pageName = name
    }
  },
  watch: {
    '$route' (to, from) {
      // print the page names when the route changes by passing the to and from parameters from $route
      this.setPageName(to.name)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/App.vue